import React from 'react';
import { Box, Button } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import { ATTENDANCE_STYLES } from '../../styles/attendanceStyles';

interface AttendanceDateFiltersProps {
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (date: Dayjs | null) => void;
  onToDateChange: (date: Dayjs | null) => void;
  onClear: () => void;
  fromLabel?: string;
  toLabel?: string;
  clearLabel?: string;
}

const AttendanceDateFilters: React.FC<AttendanceDateFiltersProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onClear,
  fromLabel = "From",
  toLabel = "To",
  clearLabel = "Clear",
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <DatePicker
          label={fromLabel}
          views={["month", "year"]}
          sx={ATTENDANCE_STYLES.datePicker}
          value={fromDate}
          onChange={onFromDateChange}
          disableFuture
        />
        <DatePicker
          label={toLabel}
          sx={ATTENDANCE_STYLES.datePicker}
          views={["month", "year"]}
          value={toDate}
          onChange={onToDateChange}
          disableFuture
        />
        <Button
          size="small"
          variant="outlined"
          disableElevation
          onClick={onClear}
        >
          {clearLabel}
        </Button>
      </Box>
    </LocalizationProvider>
  );
};

export default AttendanceDateFilters;